module.exports = __webpack_public_path__ + "img/reset.e813cdb1.svg";